import React from 'react';

import { Box, BoxProps } from '@tanium/react-box';

import { ExtendAndOverride } from '../../utils/ExtendAndOverride';
import { LegendItem, LegendItemProps } from './LegendItem';
import { LegendText } from './themeDefinitions';

export interface LegendItemInfo
  extends Pick<LegendItemProps, 'color' | 'label' | 'onClick' | 'onPointerOut' | 'onPointerOver'> {
  /**
   * A unique key corresponding to the item. The key must be unique among any other legend items in
   * the same list, but needn't be globally unique.
   */
  key: string | number;
}

interface LegendOwnProps {
  items: LegendItemInfo[];
}

export type LegendProps = ExtendAndOverride<LegendOwnProps, Omit<BoxProps, 'css'>>;

/**
 * A legend of items presented sequentially, wrapped inside a container.
 */
export const Legend = React.forwardRef<HTMLDivElement, LegendProps>(
  ({ items, ...boxProps }, ref): JSX.Element => (
    <Box
      py="2px"
      display="flex"
      flexWrap="wrap"
      justifyContent="center"
      fontSize={12}
      color={LegendText}
      mx={-1}
      ref={ref}
      {...boxProps}
    >
      {items.map(({ key, ...itemProps }) => (
        <Box key={key} px="4px" minWidth={0}>
          <LegendItem {...itemProps} />
        </Box>
      ))}
    </Box>
  ),
);
